import { FC } from "react";

import { TicketingFormCategory } from "@simplyk/common";
import { useFormContext, useWatch } from "react-hook-form";

import { useRateContext } from "../../Context/RateContext";

import { AuctionIdleSummary } from "./AuctionIdleSummary";
import { CustomIdleSummary } from "./CustomIdleSummary";
import { MembershipIdleSummary } from "./MembershipIdleSummary";
import { ShopIdleSummary } from "./ShopIdleSummary";
import { TicketingIdleSummary } from "./TicketingIdleSummary";

import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

interface RateIdleHeaderProps {
  title: string;
  isExpanded: boolean;
}

export const RateIdleHeader: FC<RateIdleHeaderProps> = ({ title, isExpanded }) => {
  const { rateIndex, formCategory } = useRateContext();
  const { control } = useFormContext<StepTicketsFormData>();
  const rate = (useWatch({ control, name: `rates.${rateIndex}` }) as Partial<RateData> | undefined) ?? {};

  if (formCategory === TicketingFormCategory.Auction) {
    return <AuctionIdleSummary title={title} rate={rate} isExpanded={isExpanded} />;
  }
  if (formCategory === TicketingFormCategory.Shop) {
    return <ShopIdleSummary title={title} rate={rate} isExpanded={isExpanded} />;
  }
  if (formCategory === TicketingFormCategory.Custom) {
    return <CustomIdleSummary title={title} rate={rate} isExpanded={isExpanded} />;
  }
  if (formCategory === TicketingFormCategory.MembershipV2) {
    return <MembershipIdleSummary title={title} />;
  }
  return <TicketingIdleSummary title={title} />;
};
